import { Theme } from '@mui/material';
import styled from '@mui/system/styled';

const HeaderRow = styled('div')(({ theme }: { theme?: Theme }) => ({
  width: '100%',
  height: 'auto',
  backgroundColor: theme.palette.primary.main,
  [theme.breakpoints.up('md')]: {
    backgroundColor: 'transparent'
  },
  '& .ham-burger': {
    width: '44px'
  },
  '& .header-container': {
    paddingLeft: '11px',
    paddingRight: '10px',
    [theme.breakpoints.up('sm')]: {
      width: '750px'
    },
    [theme.breakpoints.up('md')]: {
      width: '100%',
      maxWidth: '992px',
      paddingLeft: '21px',
      paddingRight: '21px'
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: '1100px',
      paddingLeft: '10px',
      paddingRight: '10px'
    },
    '& .header-grid': {
      [theme.breakpoints.down('md')]: {
        alignItems: 'center',
        height: '60px'
      },
      '& .search-icon-grid': {
        [theme.breakpoints.up('md')]: {
          paddingLeft: '30px'
        }
      }
    }
  }
}));

export default HeaderRow;
